import apibase from './baseAPI';
import apiuat from './uatAPI';

const getDownlineWithCommissionForYear = async (fromAgentId, agentId, year) => {
    const url = `/fromAgent/${fromAgentId}/agents/${agentId}/downlineWithCommission/year/${year}`;
    const result = await apibase.get(url);
    return result.data;
};

const getUplineWithCommissionForYear = async (agentId, year) => {
    const url = `/agents/${agentId}/uplineWithCommission/year/${year}`;
    const result = await apibase.get(url);
    return result.data;
};

const search = async (fromAgentId, name, branch, group, level) => {
    let params = { name };

    if (branch) params.branch = branch;
    if (group) params.group = group;
    if (level) params.level = level;

    const url = `/agents/${fromAgentId}/downline/search`;
    const result = await apibase.post(url, params);
    return result.data;
};

const profile = async id => {
    const url = `/agents/${id}`;
    const result = await apibase.get(url);
    return result.data;
};

const commissionForYear = async (agentId, year) => {
    const url = `/commissions/agent/${agentId}/year/${year}`;
    const result = await apibase.get(url);
    return result.data;
};

const groupCommissionForYear = async (agentId, year) => {
    const url = `/group-commissions/agent/${agentId}/year/${year}`;
    const result = await apibase.get(url);
    return result.data;
};

const payoutForYear = async (agentId, year) => {
    const url = `/commissions/payout/agent/${agentId}/year/${year}`;
    const result = await apibase.get(url);
    return result.data;
};

const singleSignon = async secretKey => {
    const url = `/agents/commissionTreeSignon/${secretKey}`;
    const result = await apibase.post(url);
    return result.data;
};

const getAccessibleBranch = async agentId => {
    const url = `/agents/${agentId}/getAccessibleBranch`;
    const result = await apibase.post(url);
    return result.data;
}

const tripRewards = async agentId => {
    const url = `/commission/trip/reward/agents/${agentId}/year/@latest`;
    const result = await apibase.get(url);
    return result.data;
}

const rankingByBranch = async (year, type) => {
    const url = `/commission/completedSales/year/${ year }/all-branch/${ type }`;
    const result = await apibase.get(url);
    return result.data;
}

const rankingByGroup = async (year, type) => {
    const url = `/commission/completedSales/year/${ year }/all-branch-group/${ type }`;
    const result = await apibase.get(url);
    return result.data;
}

const rankingByAgent = async (year, type) => {
    const url = `/commission/completedSales/year/${ year }/all-agent/${ type }`;
    const result = await apibase.get(url);
    return result.data;
}

const rankingAgentByBranch = async (year, type) => {
    const url = `/commission/completedSales/year/${ year }/all-branch-agent/${ type }`;
    const result = await apibase.get(url);
    return result.data;
}

const rankingAgentByGroup = async (year, branch, type) => {
    const url = `/commission/completedSales/year/${ year }/branch/${ branch }/${ type }`;
    const result = await apibase.get(url);
    return result.data;
}

const myPerformance = async (agentId, year = null) => {
    let url = `/agents/${agentId}/my/performance`;

    if (year) {
        url += `?year=${year}`;
    }

    const result = await apibase.get(url);
    return result.data;
};

const getCompletedSalesByBranchGroup = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getCompletedSalesByBranchGroup`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getCompletedSalesByBranchGroup`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getAgentCompletedSalesByDate = async  (agentID, DateRangeParams, Group, BranchID) => {
    let params = { agentID, DateRangeParams, Group, BranchID };

    const url = `/analytic/getAgentCompletedSalesByDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getAgentCompletedSalesByDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getAgentCompletedSalesByCaseType = async  (agentID, DateRangeParams, Group, BranchID, caseType) => {
    let params = { agentID, DateRangeParams, Group, BranchID, caseType };

    const url = `/analytic/getAgentCompletedSalesByCaseType`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getAgentCompletedSalesByCaseType`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getAgentCompletedSalesBySalesDate = async  (agentID, DateRangeParams, CaseType) => {
    let params = { agentID, DateRangeParams, CaseType };

    const url = `/analytic/getAgentCompletedSalesBySalesDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getAgentCompletedSalesBySalesDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getTotalAgentRecruitListBy = async  (agentID, DateRangeParams, Group, BranchID) => {
    let params = { agentID, DateRangeParams, Group, BranchID };

    const url = `/analytic/getTotalAgentRecruitListBy`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getTotalAgentRecruitListBy`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getTop10CompletedSalesByDate = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getTop10CompletedSalesByDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getTop10CompletedSalesByDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getAgentCompletedSalesListingByDate = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getAgentCompletedSalesListingByDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getAgentCompletedSalesListingByDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getTotalSalesCommissionPayoutByDate = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getTotalSalesCommissionPayoutByDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getTotalSalesCommissionPayoutByDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getAgentSalesCommissionPayoutListingByDate = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getAgentSalesCommissionPayoutListingByDate`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getAgentSalesCommissionPayoutListingByDate`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getCompletedSalesCommissionByYear = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getCompletedSalesCommissionByYear`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getCompletedSalesCommissionByYear`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getNewHireSummaryByYear = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getNewHireSummaryByYear`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getNewHireSummaryByYear`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getCompletedSalesCommissionByMonthly = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getCompletedSalesCommissionByMonthly`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getCompletedSalesCommissionByMonthly`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getTopAgentCompletedSalesByBranch = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getTopAgentCompletedSalesByBranch`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getTopAgentCompletedSalesByBranch`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getTopRankingCompletedSalesByMonth = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getTopRankingCompletedSalesByMonth`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getTopRankingCompletedSalesByMonth`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getCompletedSalesDetailsByAgentID = async  (agentID, DateRangeParams) => {
    let params = { agentID, DateRangeParams };

    const url = `/analytic/getCompletedSalesDetailsByAgentID`;
    const result = await apiuat.post(url, params);
    // const url = `/analytic/getCompletedSalesDetailsByAgentID`;
    // const result = await apibase.post(url, params);
    return result.data;
}

const getHierarchyLevelList = async  (agentId, branch, group) => {
    let params = { branch, group };

    const url = `/agents/${agentId}/downline/getHierarchyLevelList`;
    const result = await apibase.post(url, params);
    return result.data;
}

export default {
    getDownlineWithCommissionForYear,
    getUplineWithCommissionForYear,
    search, profile,
    commissionForYear, groupCommissionForYear, payoutForYear,
    singleSignon,
    getAccessibleBranch,
    tripRewards,
    rankingByBranch,
    rankingByGroup,
    rankingByAgent,
    rankingAgentByBranch,
    rankingAgentByGroup,
    myPerformance,
    getCompletedSalesByBranchGroup,
    getAgentCompletedSalesByDate,
    getAgentCompletedSalesByCaseType,
    getAgentCompletedSalesBySalesDate,
    getTotalAgentRecruitListBy,
    getTop10CompletedSalesByDate,
    getAgentCompletedSalesListingByDate,
    getTotalSalesCommissionPayoutByDate,
    getAgentSalesCommissionPayoutListingByDate,
    getCompletedSalesCommissionByYear,
    getNewHireSummaryByYear,
    getCompletedSalesCommissionByMonthly,
    getTopAgentCompletedSalesByBranch,
    getTopRankingCompletedSalesByMonth,
    getCompletedSalesDetailsByAgentID,
    getHierarchyLevelList
};

